<script>

    import { toast } from 'bulma-toast'
    import Moment from 'moment'

    import CreditsService from '../$services/credits.service'

    import DateRange from '../$components/date.range.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    
    let query = {}
    let element = null
    let loading = false

    async function getCreditsReport() {

        loading = true
        const blob = await CreditsService.getCreditsReport(query)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        let fileName = 'créditos'
        let dateStart = Moment(query.dateStart).format('DD-MM-YYYY')
        let dateEnd = Moment(query.dateEnd).format('DD-MM-YYYY')

        element.download = `${fileName}.${ dateStart }_a_${ dateEnd }.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }
</script>

<a bind:this={element} href="/" style="display: none;">.</a>


<Form on:submit={ getCreditsReport } { loading } >
    <DateRange bind:dateStart={ query.dateStart } bind:dateEnd={ query.dateEnd } />
    <div class="items-end">
        <Button type="submit" text="Descargar" icon="dowload" color="primary" {loading}/>
    </div>
</Form>